import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';

export const ListItemEligibleCountriesLabel = () => (
    <Stack vertical spacing="100">
        <Typography textStyle="bodyLarge" as="div">
            <LocalizedText textKey={TextKey.FinancialServicesCapitalBeInEligibleCountries} />
            {UnicodeEntity.Asterisk}
        </Typography>
        <Typography textStyle="bodyExtraSmall" variant="secondary" as="div">
            {UnicodeEntity.Asterisk}
            <LocalizedText textKey={TextKey.FinancialServicesCapitalEligibleCountriesList} />
        </Typography>
    </Stack>
);
